$component-class: 'sn-hero-header';

.#{$component-class} {
  &__actions-group {
    margin-top: var(--spacing-2xl);
  }
}
